<script>
import formatDate from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import { messageBoxDelete } from '@utils/message-box'
import { nlToBr } from '@utils'
export default {

  components: {

  },
  filters: {
    formatDate,
  },
  props: {
    defaultValue: {
      type: Array,
      default: () => [
        {
            "id": "a3ae10cf-ea24-48cb-9bc3-8f0368aa4b68",
            "orderNo": "IPJTS30001QSAQ7",
            "content": "有但超過結束時間一小時還未帶寵物回去。",
            "images": [],
            "questions": {},
            "creator": {
                "id": 16,
                "avatar": null,
                "name": "小捲尾 超級管理者",
                "email": "admin@j-tails.com"
            },
            "createdAt": "2022-10-06 19:06:10",
            "updatedAt": "2022-10-06 19:19:16"
        },
        {
            "id": "a3ae10cf-ea24-48cb-9bc3-8f0368aa4b68",
            "orderNo": "IPJTS30001QSAQ7",
            "content": "有次帶了很多寵物到現場預約，但超過結束時間一小時還未帶寵物回去。",
            "images": [],
            "questions": {},
            "creator": {
                "id": 16,
                "avatar": null,
                "name": "小捲尾 超級管理者",
                "email": "admin@j-tails.com"
            },
            "createdAt": "2022-10-06 19:06:10",
            "updatedAt": "2022-10-06 19:19:16"
        },
        {
            "id": "a3ae10cf-ea24-48cb-9bc3-8f0368aa4b68",
            "orderNo": "IPJTS30001QSAQ7",
            "content": "有次帶了很多結束時間一小時還未帶寵物回去。",
            "images": [],
            "questions": {},
            "creator": {
                "id": 16,
                "avatar": null,
                "name": "小捲尾 超級管理者",
                "email": "admin@j-tails.com"
            },
            "createdAt": "2022-10-06 19:06:10",
            "updatedAt": "2022-10-06 19:19:16"
        }
      ]
    },
    isOrder: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {

    }
  },
  computed: {
    currentUserGroupIds() {
      return this.$store.state.auth.currentUser.groups
    },
    hasPermission() {
      return this.currentUserGroupIds.includes(7) || this.currentUserGroupIds.includes(8)
    },
    userId() {
      return this.$store.state.auth.currentUser.id
    },
  },
  watch: {
    // defaultValue: {
    //   handler(val) {
    //     this.submitData = cloneDeep({
    //       ...val,
    //       phone: val.phoneNumber,
    //       merchantNote: val.merchantNote.replace(/<br\s\/>/g, ''),
    //       extraInfos: val.extraInfos 
    //       ?? {
    //         extraInfoPhone: [extraInfoPhone],
    //         extraInfoEmergency: [extraInfoEmergency]
    //       }
    //     })
    //   },
    //   immediate: true,
    // },
  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    nlToBr,
    tryToDeleteCommemt() {
      
    },
    async onClickRemove(id) {
      await messageBoxDelete('備註')
      this.$emit('remove', id)
    },
    editCommemt(item) {
      this.$emit('edit', item)
    }
  },
}
</script>

<template>
  <div :class="$style.PetInfoCommentList">
    <template v-if="defaultValue.length">
      <ul>
        <li 
          v-for="(item, index) in defaultValue"
          :key="index"
          class="PetInfoCommentList__item"
        >
          <div class="text-secondary"  v-html="nlToBr(item.content)"></div>
          <div class="d-flex mt-3 justify-content-between flex-lg-nowrap flex-wrap">
            <div class="text-text-light ml-2 align-self-center">-{{ item.updatedAt | formatDate() }} {{item.creator.name}}</div>
            <div class="ml-auto">
              <el-button 
                v-if="hasPermission || userId === item.creator.id"
                type="text"
                size='mini'
                @click="editCommemt(item)"
              >
                <BaseIcon name="edit" class="text-primary fs-xl align-text-top"/>
                編輯
              </el-button>
              <el-button 
                v-if="hasPermission || userId === item.creator.id"
                type="text"
                size='mini'
                @click="onClickRemove(item.id)"
              >
                  <BaseIcon name="trash-alt" class="text-primary fs-xl align-text-top"/>
                  刪除
              </el-button>
            </div>
          </div>
        </li>
      </ul>
      
    </template>
    <template v-else>
      尚無任何備註
    </template>
  </div>
</template>

<style lang="scss" module>
.PetInfoCommentList {
  :global {
    .PetInfoCommentList {
      &__title {

      }
      &__item {
        line-height: 1.65;
        background: #fff;
        border-radius: 0px 20px 20px 20px;
        padding: 1.125rem 1.25rem;
        &:not(:last-child) {
          margin-bottom: 1.25rem;
        }
      }
    }
  }
}
</style>
